"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLoadErrorMessage = getLoadErrorMessage;
exports.isPermissionDeniedError = isPermissionDeniedError;
var permission_error_1 = require("../constants/permission-error");
var legal_acceptance_1 = require("./legal-acceptance");
function isPermissionDeniedError(error) {
    if (typeof error !== "object" || error === null || !("status" in error) || error.status !== 403) {
        return false;
    }
    return (0, legal_acceptance_1.getRequiredLegalVersion)(error) === null;
}
function getLoadErrorMessage(error, fallback) {
    return isPermissionDeniedError(error) ? permission_error_1.PERMISSION_DENIED_VIEW_MESSAGE : fallback;
}
